import React, { FC } from 'react';
import { FormField, FormFieldProps } from '../FormField';
import { Button } from '../Button';

export type FormButtonProps = FormFieldProps;

export const FormButton: FC<FormButtonProps> = ({ ...props }) => {
	return <FormField control={Button} {...props} />;
};
